export class LoadingDashboardStarted {
   public static readonly type = '[Grafana Dashboard Viewer] Start Loading';
   constructor(public brickInstanceId: string) {}
}

export class LoadingDashboardCompleted {
   public static readonly type = '[Grafana Dashboard Viewer] Completed Loading';
   constructor(public brickInstanceId: string) {}
}
